import { takeLatest, put, call } from 'redux-saga/effects'
import axios from 'axios'
import { getRequest } from '../../../../utils/User/axios'
import { multiplePesticide, multiplePesticideSuccess, multiplePesticideFailed } from '../Reducer'

export default function* multiplePesticideSaga() {
  yield takeLatest(multiplePesticide.type, multiplePesticideWatcherSaga)
}

const getPesticides = (ids) => {
  getRequest(`${ process.env.REACT_APP_URL }/multiple-pesticide?ids=${ ids }`)
}

function fetch(ids) {
  return axios({
    method: 'get',
    url: `${ process.env.REACT_APP_URL }/multiple-pesticide?ids=${ ids }`,
  })
}

function* multiplePesticideWatcherSaga({ payload }) {
  try {
    const response = yield call(fetch, payload)
    yield put(multiplePesticideSuccess(response.data))
  } catch (error) {
    yield put(multiplePesticideFailed(error))
  }
}
